import { Component, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import * as XLSX from 'xlsx';
import { CommonModule } from '@angular/common';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../Loader/loader/loader.component';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';
import { SessionService } from '../../../Util/Session/session.service';
import { UploadMasterService } from '../../../Model/UploadMaster/upload-master.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { CommonService } from '../../../Model/Common/common.service';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { Router } from '@angular/router';
import { AlertSuccessComponent } from '../../Alert/alert-success/alert-success.component';

@Component({
  selector: 'app-upload-form',
  standalone: true,
  imports: [CommonModule, FormsModule, DataTablesModule, LoaderComponent, NgSelectModule],
  templateUrl: './upload-form.component.html',
  styleUrls: ['./upload-form.component.scss']
})
export class UploadFormComponent {
  isDisabled: boolean = false;
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  FillData: any[] = []
  dtTrigger: Subject<any> = new Subject<any>();
  uploadfile = null as any;
  ExcelHeaders = [{
    ESS_ExcelUploadMasterID: 1,//ShiftMaster
    Headers: ['ShiftMasterid', 'ShiftCode', 'ShiftTitle', 'InTime', 'OutTime', 'DefaultShift', 'RotationalShift	ShiftGroupName'],
  }, {
    ESS_ExcelUploadMasterID: 2,//ShiftGroupMaster
    Headers: ['ESS_ShiftGroupMasterID', 'ShiftGroupName'],
  }, {
    ESS_ExcelUploadMasterID: 3,//RoleMaster
    Headers: ['WebESSRoleMasterID', 'RoleName'],
  }, {
    ESS_ExcelUploadMasterID: 4,//SiteTypeMaster
    Headers: ['SiteTypeMasterID', 'SiteTypeName'],
  }, {
    ESS_ExcelUploadMasterID: 5,//SiteMaster
    Headers: ['Location ID', 'Location Name', 'Branch Name', 'Client Group Name', 'Max Client Name', 'IndustrySegmentGroupName', 'IndustrySegmentName', 'Rate Contract Group', 'Zone Name', 'SiteGroupName', 'SiteSubGroupName', 'ChannelGroupName', 'ChannelName', 'ServiceTypeName', 'BankName', 'Address1', 'Address2', 'City', 'State Name', 'District Name', 'Taluka Name', 'PinCode', 'TelephoneNo', 'Contact Person Name', 'Contact Person TelNo', 'Contact Person Email', 'BillType', 'Compliance', 'PFApplicable', 'ESICApplicable', 'PTApplicable', 'LWFApplicable', 'OpenMonth', 'OpenYear', 'SiteStartDate', 'SiteEndDate', 'Remark', 'IsMapped', 'SiteOwnerName', 'Latitude', 'Longitude', 'Radius', 'Accuracy', 'Altitude', 'heading', 'isMocked', 'IsAltitudeApplicable', 'AltitudeRadius', 'Multiple Gate', 'Area (SqFt)', 'Material Charge Type', 'Material Charge', 'Machinery Charge Type', 'Machinery Charge', 'Salary Calc Type', 'Salary From', 'Salary To', 'Salary Calc On', 'Billing Calc Type', 'Billing From', 'Billing To', 'Billing Calc On', 'Site Creation Date', 'IsInternalPOCApplicable', 'InternalPOCName', 'InternalPOCMobileNo', 'InternalPOCMailId', 'IsClientPOCApplicable', 'ClientPOCName', 'ClientPOCMobileNo', 'ClientPOCMailId', 'SiteOracleCode', 'SiteAlternateCode', 'SiteAgreementCopyAttachment', 'SiteAttendanceThrough', 'SiteLeaveSalarCycle', 'SiteLeaveSalary', 'SitePayoutBonusesCycle', 'SitePayoutBonus', 'SiteGratuity', 'SiteUniforms', 'SiteIsUniformsDeposit', 'SiteMinimumWageIndustry', 'SiteMinimumWageZone', 'SiteMinimumWageStructure', 'SiteBillTo', 'SiteShipTo', 'SiteAutoMail', 'SitePlaceOfSupplyApplicable', 'SiteDefaultNarration'],
  },
  {
    ESS_ExcelUploadMasterID: 6,//ClientMaster
    Headers: ['ClientGroupMasterID', 'CustomerName', 'RateApplicableName', 'ClientOwnerName', 'AdminChargs', 'ControlAccCode', 'ClientGroup', 'CurrencyCode', 'CreditTerms', 'CreditPeriod', 'PANNo', 'TANNo', 'TTLPartyTypeCode', 'KorectGLCode','AliasName','Email','Website','OptYes','AutoRoundOff','Branch','Address1','Address2','Address3','Address4','CityName','DistrictName','StateName','TelephoneNo','TelephoneNo2','PinCode','ContactPerson','Designation','ContactPersonMobileNo','ContactPersonLandlineNo','ContactPersonEmailID','AreaName','BillTo','ShipTo','PlaceOfSupplyApplicable','BusinessType','GSTState','GSTNo','GSTExempt','GSTExemptReason','SEZCustomer','SEZGSTExempt','SEZLetterNo','RCMApplicable','TDS_Comp','TDS194','TDSOn','TDSRoundOff','STRegister','VATDate','CSTRegister','CSTDate','CreditExceed','BankName','AccountNumber','RTGSCode','MICRCode','BankMarking','CreditLimit','CustomerType','AutoMail','CentralExciseCommissionRate','ExciseCollectoRate','MSMENo','MSMESector','DateOfRegistration','DateOfDeclaration','LowerTDSApplicable','LowerTDSCertificateNo','LowerTDSValidFrom','LowerTDSValidTo','LowerTDSPercentage','LowerTDSAmount','AgreementStartDate','AgreementEndDate','Notes','DefaultNarration'],
  },
  ];

  excelcheck = false;
  allowsubmit = false;
  dtOptions: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: false,
    paging: false,
    scrollY: '350px',
    scrollCollapse: true,
    pageLength: 10,
    info: false,
    lengthMenu: [10, 25, 50, 100],
    language: {
      searchPlaceholder: 'Search...',
    },
    ordering: false,
    stateSave: true,
    processing: false,
    order: [[0, 'asc']],
    data: [], // Initialize with empty array
    columns: [{
      title: '#',
      data: null,
      render: (data, type, row, meta) => {
        return `<strong>${meta.row + (meta.settings.displayStart ?? 0) + 1}</strong>`;
      },
      orderable: true,
    }]
  };

  Filter = {
    ESS_ExcelUploadMasterId: null as any,
    CompanyCode: null,
    UserId: null,
    MasterName: null,
  }

  Masters = [] as any;

  constructor(
    private toast: ToastService,
    private modalService: NgbModal,
    private employeeRegistration: EmployeeRegistrationService,
    private uploadMaster: UploadMasterService,
    private cdr: ChangeDetectorRef,
    private session: SessionService,
    private download: DownloadSampleService,
    private common: CommonService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.ESS_AdditionalFillCombo();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ngAfterViewInit(): void {
    // Only trigger if we have data
    if (this.FillData.length > 0) {
      this.dtTrigger.next(null);
    }
    this.Filter.CompanyCode = this.session.GetUserDetails().CompanyCode;
    this.Filter.UserId = this.session.GetUserDetails().UserId;
  }

  handleFileInputChange(event: any): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.uploadfile = file;
      input.value = '';
    } else {
      this.uploadfile = null;
      console.log('No file selected or file selection cancelled');
    }
  }

  uploadfileData() {
    if (this.Filter.ESS_ExcelUploadMasterId == null || this.Filter.ESS_ExcelUploadMasterId < 0) {
      this.toast.show({ message: 'Please select master.', type: toastTypeEnum.warning });
    } else if (this.uploadfile == null) {
      this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.warning });
    } else {
      this.handleFileInput()
    }
  }

  handleFileInput(): void {
    const file: File = this.uploadfile;
    const fileType: string | undefined = file.name.split('.').pop();
    if (fileType !== 'xlsx' && fileType !== 'xls') {
      this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
      return;
    }
    this.processExcelFile(file);
  }

  processExcelFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = 'Sheet1';
        if (!workbook.SheetNames.includes(sheetName)) {
          const errorMessage = 'Sheet1 not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        if (excelData.length > 1) {
          const headerRow = excelData[0];
          const headers = headerRow.map((header: string) => header.trim());
          this.allowsubmit = false;
          this.excelcheck = true;

          if (this.ExcelHeaders.filter(e => e.ESS_ExcelUploadMasterID == this.Filter.ESS_ExcelUploadMasterId).length > 0) {
            this.ExcelHeaders.filter(e => e.ESS_ExcelUploadMasterID == this.Filter.ESS_ExcelUploadMasterId)[0].Headers.forEach(element => {
              if (this.excelcheck) {
                if (headers.findIndex(e => this.common.ToLowerCase(e) == this.common.ToLowerCase(element)) >= 0) {
                  this.excelcheck = true;
                } else {
                  this.excelcheck = false;
                }
              }

              if (!this.excelcheck) {
                return;
              }
            });
          }

          if (!this.excelcheck) {
            this.reset();
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = "Excel file column not match. please check sample file";
            modalRef.result.then((result: any) => { });
          } else {
            this.allowsubmit = true;
            this.submit();
          }
        } else {
          this.reset();
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = "Excel file have a no data";
          modalRef.result.then((result: any) => { });
        }




        //const dataRows = excelData.slice(1);

        //const uniqueshiftgroupIds: Set<number> = new Set();
        //const shiftgroupNames: Set<string> = new Set();
        //this.FillData = [];

        // for (let rowIndex = 0; rowIndex < dataRows.length; rowIndex++) {
        //   const row = dataRows[rowIndex];
        //   const rowData: any = {};

        //   row.forEach((cellData, index) => {
        //     rowData[headers[index]] = cellData;
        //   });

        //   const id = rowData['ESS_ShiftGroupMasterID'];
        //   let shiftgroupName = rowData['ShiftGroupName']?.toString() || '';

        //   shiftgroupName = shiftgroupName ? shiftgroupName.trim() : '';

        //   if (id !== 0 && id !== '' && id !== undefined && uniqueshiftgroupIds.has(id)) {
        //     this.toast.show({ message: `Duplicate ESS_ShiftGroupMaster ID '${id}' found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
        //     return;
        //   } else {
        //     uniqueshiftgroupIds.add(id);
        //   }

        //   if (shiftgroupName === '' || shiftgroupName === null || shiftgroupName === undefined) {
        //     this.toast.show({ message: `Shift group name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
        //     return;
        //   }
        //   else if (shiftgroupNames.has(shiftgroupName)) {
        //     this.toast.show({ message: `Duplicate Shift Group Name "${shiftgroupName}" found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
        //     return;
        //   } else {
        //     shiftgroupNames.add(shiftgroupName);
        //   }
        //   rowData['ShiftGroupName'] = shiftgroupName;
        //   this.FillData.push(rowData);
        // }

        //console.log('Filled Data:', this.FillData);

        // Update dtOptions with new data
        //this.dtOptions.data = this.FillData;

        // Trigger change detection
        //this.cdr.detectChanges();

        // Now fill columns and render table
        //this.FillColumn();
      } else {
        console.error('Failed to read the file.');
      }
    };
    reader.readAsBinaryString(file);
  }

  // FillColumn() {
  //   // Update dtOptions with current data
  //   this.dtOptions.data = this.FillData;
  //   this.dtOptions.columns = this.getColumns();

  //   // Use setTimeout to ensure Angular has updated the view
  //   setTimeout(() => {
  //     if (this.dtElement && this.dtElement.dtInstance) {
  //       this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //         dtInstance.destroy();
  //         this.dtTrigger.next(null);
  //         console.log('DataTable destroyed and re-rendered');
  //       }).catch(error => {
  //         console.error('Error destroying DataTable:', error);
  //         this.dtTrigger.next(null);
  //       });
  //     } else {
  //       console.log('Initial DataTable rendering');
  //       this.dtTrigger.next(null);
  //     }
  //   }, 100);
  // }

  // getColumns(): any[] {
  //   const columns: any[] = [];

  //   // Serial number column
  //   columns.push({
  //     title: '#',
  //     data: null,
  //     render: (data: any, type: any, row: any, meta: any) => {
  //       return `<strong>${meta.row + (meta.settings.displayStart ?? 0) + 1}</strong>`;
  //     },
  //     orderable: true,
  //     width: '50px',
  //     className: 'text-center'
  //   });

  //   // ShiftGroupName column
  //   if (this.FillData.length > 0 && this.FillData.some(row => row.ShiftGroupName)) {
  //     columns.push({
  //       title: 'Shift Group Name',
  //       data: 'ShiftGroupName',
  //       orderable: true,
  //       render: (data: any) => {
  //         return data || '';
  //       }
  //     });
  //   }

  //   // Action column
  //   // columns.push({
  //   //   title: 'Action',
  //   //   data: null,
  //   //   render: (data: any, type: any, row: any, meta: any) => {
  //   //     return `
  //   //       <button type="button" 
  //   //               class="btn btn-sm btn-outline-danger delete-btn" 
  //   //               title="Delete" 
  //   //               data-index="${meta.row}"
  //   //               style="color: rgb(236, 4, 4);">
  //   //         <i class="bi bi-trash-fill"></i>
  //   //       </button>
  //   //     `;
  //   //   },
  //   //   orderable: false,
  //   //   width: '50px',
  //   //   className: 'text-center',
  //   //   createdCell: (td: any, cellData: any, rowData: any, rowIndex: any, colIndex: any) => {
  //   //     const button = $(td).find('.delete-btn');

  //   //     button.on('click', (e) => {
  //   //       e.preventDefault();
  //   //       e.stopPropagation();
  //   //       const index = $(e.currentTarget).data('index');
  //   //       this.Delete(index);
  //   //     });
  //   //   }
  //   // });

  //   return columns;
  // }

  // Delete(index: number) {
  //   const modalRef = this.modalService.open(ConfirmationComponent);
  //   modalRef.componentInstance.Message = 'Do you want to delete?';
  //   modalRef.result.then(result => {
  //     if (result) {
  //       this.FillData.splice(index, 1);

  //       // Update the DataTable
  //       this.dtOptions.data = this.FillData;

  //       // Re-render the table
  //       if (this.dtElement && this.dtElement.dtInstance) {
  //         this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
  //           dtInstance.clear();
  //           dtInstance.rows.add(this.FillData);
  //           dtInstance.draw();
  //         });
  //       }
  //     }
  //   }).catch(() => {
  //     // Modal dismissed
  //   });
  // }

  reset() {
    // const modalRef = this.modalService.open(ConfirmationComponent);
    // modalRef.componentInstance.Message = 'Do you want to reset?';
    // modalRef.result.then(result => {
    //   if (result) {
    this.allowsubmit = false;
    this.FillData = [];
    this.dtOptions.data = [];

    if (this.dtElement && this.dtElement.dtInstance) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.clear().draw();
      });
    }
    this.removeFile();

    //   }
    // }).catch(() => {
    //   // Modal dismissed
    // });
  }

  removeFile() {
    this.setallowsubmit();
    this.uploadfile = null;
  }

  ESS_AdditionalFillCombo() {
    this.isDisabled = true;
    this.Masters = [];

    this.employeeRegistration.ESS_AdditionalFillCombo({
      'SelectType': 'ESS_ExcelUploadMaster', UserId: this.session.GetUserDetails().UserId
    }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.Masters = response.Table;
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  submit() {
    if (this.allowsubmit) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to submit?';
      modalRef.result.then(result => {
        if (result) {
          this.isDisabled = true;
          this.Filter.MasterName = this.Masters.filter((e: any) => e.ESS_ExcelUploadMasterID == this.Filter.ESS_ExcelUploadMasterId)[0].ExcelUploadName;
          this.uploadMaster.CommonMasterExcelupload(this.uploadfile, this.Filter).subscribe({
            next: (response) => {
              if (response.Error_Code == "874") {
                const modalRef = this.modalService.open(AlertSuccessComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => {
                  if (result) {
                    this.router.navigate(['uploadmaster']);
                  }
                });
              } else {
                const modalRef = this.modalService.open(AlertWarningComponent, {
                  size: 'md',
                  backdrop: 'static',
                  centered: true,
                  windowClass: 'confirmation-modal'
                });
                modalRef.componentInstance.Message = response.Error_Message;
                modalRef.result.then((result: any) => { });
              }

              this.isDisabled = false;
            },
            complete: () => {
            },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      });
    }
  }

  downloadExcel() {
    if (this.Filter.ESS_ExcelUploadMasterId > 0) {
      this.download.downloadExcel(this.Masters.filter((e: any) => e.ESS_ExcelUploadMasterID == this.Filter.ESS_ExcelUploadMasterId)[0].SampleFileName.split('.')[0]);
    } else {
      this.toast.show({ message: 'Please select master.', type: toastTypeEnum.warning });
    }
  }

  setallowsubmit() {
    this.allowsubmit = false;
  }
}